module.exports = __webpack_public_path__ + "img/microsoftStore.df26f440.png";